var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeHeader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99778 19.3274V14.3274H13.9978V19.3274C13.9978 19.8774 14.4478 20.3274 14.9978 20.3274H17.9978C18.5478 20.3274 18.9978 19.8774 18.9978 19.3274V12.3274H20.6978C21.1578 12.3274 21.3778 11.7574 21.0278 11.4574L12.6678 3.92736C12.2878 3.58736 11.7078 3.58736 11.3278 3.92736L2.96778 11.4574C2.62778 11.7574 2.83778 12.3274 3.29778 12.3274H4.99778V19.3274C4.99778 19.8774 5.44778 20.3274 5.99778 20.3274H8.99778C9.54778 20.3274 9.99778 19.8774 9.99778 19.3274Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeHeader);
export default __webpack_public_path__ + "static/media/home_header.b36b5baf31707b9208661d2556cbf622.svg";
export { ForwardRef as ReactComponent };